module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-9e2eec749f2c494e836f3e8ee2e64182.png";